import { FC, ReactNode } from 'react';

import clsx from 'clsx';
import styles from './PdpLayout.module.scss';

interface Props {
  hero: ReactNode;
  gallery: ReactNode;
  price: ReactNode;
  children: ReactNode;
}

export const PdpLayout: FC<Props> = ({ hero, gallery, price, children }) => {
  return (
    <section className={clsx(styles.root, 'header-transparent')}>
      <div className={styles.hero}>{hero}</div>
      <aside className={styles.price}>
        <div className={styles.priceContent}>{price}</div>
      </aside>
      <div className={styles.gallery}>{gallery}</div>
      <div className={styles.content}>{children}</div>
    </section>
  );
};
